import React, { Component } from "react";
import { connect } from "react-redux";
import MapGL, { Marker } from "react-map-gl";
import Styles from "./detail-map.module.scss";
import DirectionOverlay from "../direction-overlay";

import pin from "./pin.svg";
import { selectDuration } from "../../ducks/time";

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
const INITIAL_VIEW_STATE = {
    latitude: -37.81917910528,
    longitude: 144.95401578986773,
    zoom: 13,
    bearing: 0,
    pitch: 0,
    width: 180,
    height: 100,
};

class DetailMap extends Component {
    constructor(props) {
        super(props);
        const coords = props.video.details.Data.CameraLocation;
        this.state = {
            viewport: {
                ...INITIAL_VIEW_STATE,
                longitude: coords.lon,
                latitude: coords.lat,
            },
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.duration && this.props.duration) {
            this.resize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        if (!this.container) return;
        const bbox = this.container.getBoundingClientRect();
        const { width, height } = bbox;
        this.setState({
            viewport: {
                ...this.state.viewport,
                width,
                height,
            },
        });
    };

    render() {
        const { video, duration } = this.props;
        if (!duration) return null;
        const cameraCoords = video.details.Data.CameraLocation;
        return (
            <div className={Styles.detailMap} ref={r => (this.container = r)}>
                <MapGL
                    mapboxApiAccessToken={MAPBOX_TOKEN}
                    reuseMaps
                    mapStyle="mapbox://styles/mapbox/dark-v9"
                    preventStyleDiffing
                    onViewportChange={viewport => this.setState({ viewport })}
                    {...this.state.viewport}
                >
                    <Marker
                        longitude={cameraCoords.lon}
                        latitude={cameraCoords.lat}
                    >
                        <div>
                            <img className={Styles.pin} src={pin} alt=""/>
                        </div>
                    </Marker>
                    <DirectionOverlay />
                </MapGL>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        duration: selectDuration(state),
    };
};
const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailMap);



// WEBPACK FOOTER //
// ./src/components/detail-map/detail-map.js